import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ShowroomService } from '../../../../services/showroom/showroom.service';
import { TokenService } from '../../../../services/token.service';
import { Showroom } from '../../../../models/showroom/showroom';

@Component({
	selector: 'm-menu-horizontal',
	templateUrl: './menu-horizontal.component.html',
	styleUrls: ['./menu-horizontal.scss']
})
export class MenuHorizontalComponent implements OnInit {

	company: any = {
		name: '',
		location: {
			name: null
		}
	}
	
	constructor(
		private showroomService: ShowroomService, 
		private ref: ChangeDetectorRef,
		private tokenService: TokenService,
	) {}

	ngOnInit() {
		if (this.tokenService.user.role == 'sales' || this.tokenService.user.role == 'showroom_admin') {
			this.setShowroomName();
		} else if (this.tokenService.user.role == 'superadmin') {
			this.company.name = 'Persist Digital';	
			this.ref.detectChanges();		
		} else if (this.tokenService.user.vendor) {
			this.company.name = this.tokenService.user.vendor.name;
			this.ref.detectChanges();
		}
	}

	/**
	 * If user belongs to a showroom we'll get showroom name and set it on the header.
	 */
	private setShowroomName() {
		this.showroomService.getShowroomInfo().subscribe(
			(showroom: Showroom) => {
				this.company = showroom;
				this.ref.detectChanges();
			},
			error => {
				console.log(error);
			}
		)
	}

}
